import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class LogicScale extends DesigntimeComponent {
    static staticName = "Logic: Scale";
    static staticId = "logicScale";
    hasRuntimeView = false;

    constructor(identifyer) {
        super(identifyer, 1);

        this.values = {};

        this.params = {
            proContinue: { key: "url:monthlySpending", value: 0 },
            antiContinue: { key: "url:monthlySpending", value: 0 },
            antiChange: { key: "url:monthlySpending", value: 0 },
            proChange: { key: "url:monthlySpending", value: 0 }
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));
        return $("<div class='logicScale'></div>");
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == this.id)
            return;

        for (var paramIndex in this.params) {
            var param = this.params[paramIndex];
            if (param.key == eventParams.key) {
                param.value = eventParams.value;
                this.calculateValue();
            }
        }
    }

    calculateValue() {
        var continueSum = this.params.proContinue.value - this.params.antiContinue.value;
        var changeSum = this.params.proChange.value - this.params.antiChange.value;
        var result = 0;
        if (continueSum > changeSum)
            result = 1; // continue gambling won
        if (continueSum == changeSum)
            result = 2; // equal
        if (continueSum < changeSum)
            result = 3; // change won

        this.eventBroker.fireValueChanged(this.id, "value", result);
    }

    output = [
        { name: "value", type: "number" }
    ];
}

export { LogicScale }
